import React, { useContext } from 'react';
import { makeStyles, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import CardBlock from '../../common/forms/CardBlock';
import Subtitle2 from '../../common/typographys/Subtitle2';
import SelectOutlined from '../../common/forms/SelectOutlined';
import Body1 from '../../common/typographys/Body1';
import { MeetingDispatchContext } from '../CreateEditMeetingsProvider';
import uniqBy from 'lodash/uniqBy';

const useStyles = makeStyles(() => ({
  label: {
    marginBottom: '8px',
  },
  mainBox: {
    marginTop: '8px',
  },
}));

const findUser = (usersState, userId) => {
  const userGroups = usersState ? usersState.users : [];

  for (let i = 0; i < userGroups.length; ++i) {
    const groupOrUser = userGroups[i];

    if (Array.isArray(groupOrUser.users)) {
      for (let j = 0; j < groupOrUser.users.length; ++j) {
        const user = groupOrUser.users[j];

        if (user.id === userId) {
          return {
            idxGroup: i,
            idGroup: groupOrUser.id,
            user,
          };
        }
      }
    } else if (groupOrUser.id === userId) {
      return {
        user: groupOrUser,
      };
    }
  }

  return {};
};

const NewMeetingSupervisors = ({ state, usersState }) => {
  const dispatch = useContext(MeetingDispatchContext);
  const classes = useStyles();
  const { supervisors, availableObservers = [] } = state;
  const { observers = [] } = supervisors || {};

  const addObserver = (value, userId) => {
    const actionType = value !== null ? 'ADD_OBSERVER' : 'REMOVE_OBSERVER';

    dispatch({
      type: actionType,
      payload: {
        id: userId,
        value,
      },
    });

    if (actionType === 'ADD_OBSERVER') {
      const { idxGroup, idGroup, user } = findUser(usersState, value.id);

      if (!user) return;

      dispatch({
        type: usersState && usersState.isGroup ? 'REMOVE_GROUP_USER' : 'REMOVE_USER',
        payload: {
          idxGroup,
          idUser: user.id,
          user,
          idGroup,
        },
      });
    } else if (actionType === 'REMOVE_OBSERVER') {
      if (usersState && usersState.isGroup) {
        const { idxGroup, idGroup, user } = findUser(usersState, userId);

        if (!user) return;

        dispatch({
          type: 'ADD_GROUP_USER',
          payload: {
            idxGroup,
            user,
            idGroup,
          },
        });
      } else {
        dispatch({
          type: 'ADD_NEW_USER',
          payload: {
            user: observers.find(obs => obs.id === userId),
          },
        });
      }
    }
  };

  return (
    <CardBlock label="Supervisores">
      <Subtitle2 className={classes.label}>
        Observador{observers.length !== 1 ? 'es' : ''}
      </Subtitle2>
      {uniqBy(observers, 'id').map((user, idx) => (
        <React.Fragment key={user.id}>
          <SelectOutlined
            name={`observer-${user.id}`}
            options={availableObservers.filter(
              x => observers.find(u => u.id === x.id) === undefined
            )}
            value={user}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            otherClasses={classes}
            onChange={val => addObserver(val, user.id)}
            noOptionsMessage={() => 'Sem observadores disponíveis para substituir.'}
            hideSelectedOptions
            isClearable
          />
          {idx !== observers.length - 1 && <Box height="8px" />}
        </React.Fragment>
      ))}
      {observers.length !== availableObservers.length && (
        <>
          {observers.length > 0 && <Box height="12px" />}
          <Box className={classes.mainBox}>
            <SelectOutlined
              name="observer-new-add"
              options={availableObservers.filter(
                x => observers.find(u => u.id === x.id) === undefined
              )}
              value={null}
              placeholder={`Adicionar ${observers.length > 0 ? 'novo' : ''} observador`}
              getOptionLabel={option => option.name}
              getOptionValue={option => option.id}
              otherClasses={classes}
              onChange={val => addObserver(val)}
              noOptionsMessage={() => 'Nenhum observador disponível para adicionar.'}
              hideSelectedOptions
              hideRemove
            />
          </Box>
        </>
      )}
      {availableObservers.length === 0 && (
        <Body1 secondary>Não existem utilizadores com permissão de observador.</Body1>
      )}
    </CardBlock>
  );
};

NewMeetingSupervisors.propTypes = {
  state: PropTypes.object.isRequired,
  usersState: PropTypes.object.isRequired,
};

export default React.memo(NewMeetingSupervisors);
